import React from 'react';
import PropTypes from 'prop-types';

import Section from 'components/structure/Section';
import TabNavLinks from 'components/tab/TabNavLinks/TabNavLinks';

import SectionHero from './components/SectionHero/SectionHero';

const tabLinkData = [
  {
    linkText: 'SERVICE_CHANNELS.PAGE_HEADING.TAB',
    href: '/dados-abertos',
  },
  {
    linkText: 'EXCHANGE_RATE.PAGE_HEADING.TAB',
    href: '/taxas-conversao',
  },
];

function OpenDataPage({ children }) {
  return (
    <>
      <SectionHero />

      <Section minHeight="1em">
        <TabNavLinks links={tabLinkData} />
      </Section>

      {children}
    </>
  );
}

OpenDataPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OpenDataPage;
